import { Compass, Check } from 'lucide-react';
import { cn } from '../../lib/utils';
import { TRAVEL_STYLES } from './tripConstants';

export const StyleStep = ({ formData, toggleArrayItem }) => (
  <div className="space-y-6">
    <div className="flex items-center gap-3 mb-6">
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-sky to-ocean flex items-center justify-center text-white shadow-lg">
        <Compass className="w-6 h-6" />
      </div>
      <div>
        <h3 className="text-xl font-semibold text-ocean">What's your travel style?</h3>
        <p className="text-ocean/70 text-sm">Select all that apply</p>
      </div>
    </div>
    <div className="flex flex-wrap gap-3">
      {TRAVEL_STYLES.map((style) => (
        <button key={style.value}
          onClick={() => toggleArrayItem('travel_styles', style.value)}
          className={cn('inline-flex items-center gap-2 px-5 py-3 rounded-full border-2 transition-all duration-300',
            formData.travel_styles.includes(style.value)
              ? 'border-gold bg-gradient-to-r from-gold to-gold-light text-ocean shadow-lg scale-105'
              : 'border-ocean/20 bg-white/50 hover:border-gold/50 hover:shadow-md text-ocean backdrop-blur-sm')}
          data-testid={`style-${style.value}`}>
          {style.label}
          {formData.travel_styles.includes(style.value) && <Check className="w-4 h-4 ml-1" />}
        </button>
      ))}
    </div>
  </div>
);
